import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import SingleProgressBar, { ProgressData } from './SingleProgressBar';

const MovementCard: React.FC<{
  title: string;
  movementData: ProgressData[];
  barColor: string;
  subTextTooltip?: string;
}> = ({
  title,
  movementData,
  barColor,
  subTextTooltip = 'Wow % change in index for this country, platform or channel',
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const MOVEMENT_THRESHOLD = 5;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: isMobile ? '100%' : '33.33%',
        gap: '0.5rem',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Manrope, sans-serif',
          fontWeight: 700,
          fontSize: '0.75rem',
          lineHeight: '1rem',
          color: '#6C6C6C',
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          border: '1px solid #2F736E1F',
          borderRadius: '0.5rem',
          padding: '1rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75rem',
          height: '100%',
        }}
      >
        {movementData.length > 0 &&
        movementData.some(
          (data) => data.weekAdSharePercent && data.weekAdSharePercent >= MOVEMENT_THRESHOLD,
        ) ? (
          <>
            {movementData.map((data) => (
              <>
                {data.weekAdSharePercent && data.weekAdSharePercent >= MOVEMENT_THRESHOLD ? (
                  <SingleProgressBar
                    key={data.name}
                    progressData={[data]}
                    textColor="#6C6C6C"
                    barColor={barColor}
                    showPercentageChange
                    subTextTooltip={subTextTooltip}
                  />
                ) : (
                  <></>
                )}
              </>
            ))}
          </>
        ) : (
          <Box
            sx={{
              height: '100%',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            No data
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MovementCard;
